import { useContext } from "react";
import { UserCtx } from "../contexts/UserCtx";

function useUser()
{
	return useContext(UserCtx);
}

export default useUser;
